import { apiWrapper } from '../../config/api-wrapper';
import { AuditLogRequest, AuditLogResponse } from './audit-log.types';

class AuditLogService {
  private static readonly BASE_URL = '/audit-logs';

  public search(request: AuditLogRequest): Promise<AuditLogResponse> {
    return apiWrapper.adminApi
      .post<AuditLogResponse>(AuditLogService.BASE_URL, request)
      .then((response) => response.data);
  }
}

export default new AuditLogService();